import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const FormPaneContainer = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;

  ${mediaQuery('md')} {
    flex-direction: row;
  }
`;
